import useTracker from '@hooks/useTracker';
import { CLICK_FORGOT_PIN, CLICK_SUBMIT_PIN, VISIT_PIN_PAGE } from '@services/trackerConst';

const useEventTracker = () => {
  const { trackEvent } = useTracker();

  const eventVisitPinPage = () => {
    trackEvent(VISIT_PIN_PAGE);
  };

  const eventClickForgotPin = () => {
    trackEvent(CLICK_FORGOT_PIN);
  };

  const eventSubmitPin = (props) => {
    trackEvent(CLICK_SUBMIT_PIN, props);
  };

  return {
    eventVisitPinPage,
    eventClickForgotPin,
    eventSubmitPin,
  };
};

export default useEventTracker;
